import WithLoading from "shared/hocs/withLoading";
import CommonPage from "./common-page";

export const PageWithLoading = WithLoading(CommonPage);
